// Matches app/views/site/_hovercard_template.html.erb which is the template used in the rest of the monolith
// This component's contents get set by app/assets/modules/github/behaviors/hovercards.ts

import {clsx} from 'clsx'

import styles from './PreviewCard.module.css'

export function PreviewCardOutlet() {
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    <div className={clsx(styles.PreviewCardOutlet, 'Popover js-hovercard-content')} tabIndex={0}>
      <div
        className="Popover-message Popover-message--bottom-left Popover-message--large Box color-shadow-large"
        style={{width: '360px'}}
      />
    </div>
  )
}
